import { Link } from "react-router-dom";
import { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-blue-600 text-white py-2 shadow-md fixed top-0 left-0 w-full z-50">
      <div className="max-w-8xl mx-auto flex justify-between items-center px-4 md:justify-center">
        {/* Title and Navigation Container */}
        <div className="flex items-center w-full md:w-auto md:gap-8">
          {/* Logo / Title */}
          <h1 className="text-xl font-bold">
            <Link to="/">Build Pro Resume</Link>
          </h1>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex md:items-center md:gap-8">
            <ul className="flex space-x-6">
              <li>
                <Link to="/" className="text-white hover:underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:underline">
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/resume"
                  className="bg-white text-blue-600 font-semibold rounded-md px-4 py-2 shadow-md hover:bg-gray-200 transition"
                >
                  Start Now
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            <XMarkIcon className="w-6 h-6" />
          ) : (
            <Bars3Icon className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Mobile Navigation (Ensuring Clickable) */}
      <nav
        className={`absolute top-14 left-0 w-full bg-blue-700 transition-all duration-300 z-50 ${
          isOpen ? "block" : "hidden"
        } md:hidden`}
      >
        <ul className="flex flex-col items-center py-2">
          <li>
            <Link
              to="/"
              className="block px-4 py-2 text-white hover:bg-blue-500"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="block px-4 py-2 text-white hover:bg-blue-500"
              onClick={() => setIsOpen(false)}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="block px-4 py-2 text-white hover:bg-blue-500"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
          </li>
          <li>
            <Link
              to="/resume"
              className="block px-4 py-2 bg-white text-blue-600 font-semibold rounded-md shadow-md hover:bg-gray-200 transition"
              onClick={() => setIsOpen(false)}
            >
              Start Now
            </Link>
          </li>
        </ul>
      </nav>

      {/* Mobile Overlay (Ensuring Clicks Work) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden pointer-events-none"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </header>
  );
}

export default Header;
